import React from 'react'
import PropTypes from 'prop-types'

import Slide from '../components/Slide.jsx'
import Margin from '../components/Margin.jsx'
import Text from '../components/Text.jsx'
import Align from '../components/Align.jsx'
import Grid from '../components/Grid.jsx'

import usePosition from '../hooks/usePosition.js'
import useRect from '../hooks/useRect.js'

import backgroundImage from '_static/img/audience-insights/slides/section_bg-outro.png'
import logo from '_static/img/data-logo-white.png'
import datasphereLogo from '_static/img/datasphere-white.png'

const Outro = (props) => {
  const { title, name, email } = props

  const [Rect, rect] = useRect()
  const [messageRef, messageRect] = usePosition()
  const [signatureRef, signatureRect] = usePosition()
  const [poweredByRef, poweredByRect] = usePosition()

  const [GridRect, gridRect] = useRect()

  return (
    <Slide>
      <Rect />
      <image href={backgroundImage} height={rect.height} width={rect.width} x={0} y={0} />
      <Align
        childrenRect={{
          width: 540,
          height: 92 + 193 / 4 + 32, // logo height + datasphere height + gap
        }}
        x="center"
      >
        <Grid
          direction="vertical"
          align={{ y: 'bottom', x: 'center' }}
          gap={32}
          items={[
            {
              component: <image href={logo} width={540} height={92} />,
              size: { width: 540, height: 92 },
            },
            {
              component: (
                <Align
                  childrenRect={{
                    width: poweredByRect.width + 16 + 1000 / 4, // sum of children
                    height: 193 / 4, // same as image's height bellow
                  }}
                  x="center"
                  y="bottom"
                >
                  <Text
                    value="Powered by"
                    gRef={poweredByRef}
                    width={700}
                    fill="#ffffff"
                    fontSize={40}
                    fontWeight={400}
                  />
                  <image
                    href={datasphereLogo}
                    x={poweredByRect.width + 16}
                    width={1000 / 4} // original image width
                    height={193 / 4} // original image height
                  />
                </Align>
              ),
              size: {
                // same as Align props
                width: poweredByRect.width + 16 + 1000 / 4,
                height: 193 / 4,
              },
            },
          ]}
        />
      </Align>
      <Margin left={240} top={176} right={240} bottom={176}>
        <GridRect />
        <Grid
          direction="vertical"
          gap={16}
          align={{ y: 'bottom', x: 'center' }}
          items={[
            {
              component: (
                <Text
                  value={title}
                  gRef={messageRef}
                  width={gridRect.width}
                  fill="#ffffff"
                  textAnchor="middle"
                  fontSize={64}
                  fontWeight={700}
                />
              ),
              size: messageRect,
            },
            {
              component: (
                <Text
                  value={`${name} | ${email}`}
                  gRef={signatureRef}
                  width={gridRect.width}
                  fill="#ffffff"
                  textAnchor="middle"
                  fontSize={32}
                  fontWeight={600}
                />
              ),
              size: signatureRect,
            },
          ]}
        />
      </Margin>
    </Slide>
  )
}

Outro.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  title: PropTypes.string,
}

Outro.defaultProps = {
  title: '',
}

export default Outro
